<script >
import { use } from '@fegobull/webapi';
import { defineProps, onMounted, ref } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = ['isEdit'];
__sfc_main.setup = (__props, __ctx) => {
  const {
    usePageType,
    useLang
  } = use;
  const {
    isPC
  } = usePageType();
  const driveType = isPC ? 'pc' : 'mobile';
  const {
    langText
  } = useLang();
  const props = __props;
  const ccContainer = ref(null);
  onMounted(() => {
    if (props.isEdit) {
      // 阻止根节点所有事件
      ccContainer.value.addEventListener('click', e => {
        e.stopPropagation();
      }, true);
    }
  });
  return {
    driveType,
    langText,
    ccContainer
  };
};
export default __sfc_main;
</script>

<template>
    <div :cc-drive-type="driveType" :cc-lang-text="langText" class="cc-container" ref="ccContainer">
        <slot />
    </div>
</template>

<style scoped>
.cc-container {
    height: auto !important;
    overflow: visible !important;
    font-size: 0.24rem;
    margin: 0 auto;
}
</style>
